import { render, staticRenderFns } from "./dialog-item.vue?vue&type=template&id=19a3d4bd&"
import script from "./dialog-item.vue?vue&type=script&lang=js&"
export * from "./dialog-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports